import { render, staticRenderFns } from "./TaxPph22ImportView.vue?vue&type=template&id=4eea34c8"
import script from "./TaxPph22ImportView.vue?vue&type=script&lang=js"
export * from "./TaxPph22ImportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports